import { DEFAULT_BORDER_COLOR } from 'common/Prose/constants/colorOptions'

export interface BorderProperties {
  thickness: string
  style: string
  color: string
}

const defaultBorderProperties: BorderProperties = {
  thickness: '1px',
  style: 'solid',
  color: DEFAULT_BORDER_COLOR,
}

export function parseBorderAttr(attr: any): BorderProperties {
  if (typeof attr !== 'string') return defaultBorderProperties
  const [thickness, style, color] = attr.split(' ')
  return {
    thickness: thickness || defaultBorderProperties.thickness,
    style: style || defaultBorderProperties.style,
    color: color || defaultBorderProperties.color,
  }
}

export function buildBorderAttr({ color, style, thickness }: BorderProperties): string {
  return [thickness, style, color].join(' ')
}
